// Helpers de formatage des dates et heures (locale fr-FR)
// Toujours afficher les dates au format JJ/MM/AAAA et les heures au format HH:MM (24h).

const PAD = (n) => String(n).padStart(2, "0");

// Accepte :
//   - "YYYY-MM-DD"          (ex. valeur d'un <input type="date">)
//   - "YYYY-MM-DDTHH:mm..." (ISO complet)
//   - un objet Date
//   - null / undefined / ""  → renvoie ""
// Retourne toujours "JJ/MM/AAAA" ou "" si invalide.
export function formatDateFr(value) {
  if (value == null || value === "") return "";
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    return `${PAD(value.getDate())}/${PAD(value.getMonth() + 1)}/${value.getFullYear()}`;
  }
  if (typeof value === "string") {
    // YYYY-MM-DD ou YYYY-MM-DDTxx (parse manuel = pas de bascule timezone)
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) {
      return `${PAD(d.getDate())}/${PAD(d.getMonth() + 1)}/${d.getFullYear()}`;
    }
  }
  return "";
}

// Format date + heure (fr) — JJ/MM/AAAA HH:MM
export function formatDateTimeFr(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return `${PAD(d.getDate())}/${PAD(d.getMonth() + 1)}/${d.getFullYear()} ${PAD(d.getHours())}:${PAD(d.getMinutes())}`;
}

// Format heure 24h HH:MM — accepte "HH:MM", "HH:MM:SS" ou Date
export function formatTimeFr(value) {
  if (!value) return "";
  if (typeof value === "string") {
    const m = value.match(/^(\d{1,2}):(\d{2})/);
    if (m) return `${PAD(m[1])}:${m[2]}`;
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) return `${PAD(d.getHours())}:${PAD(d.getMinutes())}`;
    return "";
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return `${PAD(value.getHours())}:${PAD(value.getMinutes())}`;
  }
  return "";
}
